export interface Comment {
    id?: string;
    comment_body?: string;
    commented_by?: string;
    commented_on?: string;
}

interface AssignedTo {
    id?: string;
    name?: string;
}

export interface Tickets {
    ticket_id?: string;
    id?: string;
    title?: string;
    description?: string;
    type_of_equipment?: string;
    created_by?: string;
    created_on?: string;
    updated_by?: string;
    updated_on?: string;
    assigned_by?: string;
    assigned_to?: AssignedTo;
    assigned_on?: string;
    status?: string;
    signature?: string;
    comments?: Comment[];
    severity?: string;
    resolution_notes?: string;
    reason_for_issue?: string;
    resolved_on?: string;
    resolved_by?: string;
    closed_on?: string;
    closed_by?: string;
    upload_file?: File | null;
    entitled_for?: string;
}

export const SEVERITY_TYPES: string[] = ["Low", "Medium", "High", "Critical"];

export const statusType: string[] = [
    "Open",
    "Inprogress",
    "Resolved",
    "Closed",
    "Reopened",
];

export interface PreviewFile {
    url: string;
    isNew?: boolean;
    file?: File;
}
